// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store'; // Updated import for persistor
import { router } from './App.tsx';
import './index.css';
import './utils/axiosInterceptor';

const theme = extendTheme({
	fonts: {
		body: 'Inter',
	},
});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate loading={<div>Loading...</div>} persistor={persistor}>
				<ChakraProvider theme={theme}>
					<RouterProvider router={router} />
				</ChakraProvider>
			</PersistGate>
		</Provider>
	</React.StrictMode>
);
